const getBasketDiscountCodes = (prevBasket, currentBasket) => ({
  prevBasketDiscountCode: prevBasket.discountCode?.code || '',
  currentBasketDiscountCode: currentBasket.discountCode?.code || '',
});

export default getBasketDiscountCodes;
